export default __webpack_public_path__ + "static/media/BlogImage11.c1aa68ed.png";